/**
 * Comprehensive Phrases Data - Prepositions & Position
 * 介词和位置短语集合
 *
 * 包含方位介词和位置表达，约30个短语
 */

import { Phrase } from './phrases-types';

export const prepositionPhrases: Phrase[] = [
  // ==================== 基础方位介词 Basic Position Prepositions ====================

  // 上方和下方
  {
    id: 'prep_on',
    phrase: 'on...',
    phonetic: '/ɒn/',
    meaning: '在……上面',
    usageScenario: '描述某物在另一物体的表面上，接触面',
    example: 'There is a book on the desk.',
    exampleTranslation: '桌子上有一本书。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_on_the_table',
    phrase: 'on the table',
    phonetic: '/ɒn ðə ˈteɪbl/',
    meaning: '在桌子上',
    usageScenario: '描述物体放置在桌子表面上',
    example: 'Put your bag on the table.',
    exampleTranslation: '把你的书包放在桌子上。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_on_the_floor',
    phrase: 'on the floor',
    phonetic: '/ɒn ðə flɔːr/',
    meaning: '在地上',
    usageScenario: '描述物体在地板或地面上',
    example: "Don't put your toys on the floor.",
    exampleTranslation: '别把你的玩具放在地上。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_under',
    phrase: 'under...',
    phonetic: '/ˈʌndər/',
    meaning: '在……下面',
    usageScenario: '描述某物在另一物体的下方',
    example: 'The cat is under the table.',
    exampleTranslation: '猫在桌子下面。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_under_the_table',
    phrase: 'under the table',
    phonetic: '/ˈʌndər ðə ˈteɪbl/',
    meaning: '在桌子下面',
    usageScenario: '描述物体隐藏或放置在桌子下方',
    example: 'My shoes are under the table.',
    exampleTranslation: '我的鞋子在桌子下面。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_under_the_bed',
    phrase: 'under the bed',
    phonetic: '/ˈʌndər ðə bed/',
    meaning: '在床下面',
    usageScenario: '描述物体藏在床下',
    example: 'The dog is sleeping under the bed.',
    exampleTranslation: '狗在床下睡觉。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 内部
  {
    id: 'prep_in',
    phrase: 'in...',
    phonetic: '/ɪn/',
    meaning: '在……里面',
    usageScenario: '描述某物在容器、房间或空间的内部',
    example: 'There are apples in the box.',
    exampleTranslation: '箱子里有苹果。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_in_the_box',
    phrase: 'in the box',
    phonetic: '/ɪn ðə bɒks/',
    meaning: '在盒子里',
    usageScenario: '描述物体装在盒子内部',
    example: 'The toy is in the box.',
    exampleTranslation: '玩具在盒子里。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_in_the_bag',
    phrase: 'in the bag',
    phonetic: '/ɪn ðə bæɡ/',
    meaning: '在书包里',
    usageScenario: '描述物品放在书包内',
    example: 'My books are in the bag.',
    exampleTranslation: '我的书在书包里。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },

  // 旁边和附近
  {
    id: 'prep_next_to',
    phrase: 'next to',
    phonetic: '/nekst tuː/',
    meaning: '紧挨着……',
    usageScenario: '描述两个物体紧挨着，位置相邻',
    example: 'The school is next to the park.',
    exampleTranslation: '学校紧挨着公园。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_next_to_me',
    phrase: 'next to me',
    phonetic: '/nekst tuː miː/',
    meaning: '在我旁边',
    usageScenario: '描述某人或某物就在自己身边',
    example: 'My friend sits next to me.',
    exampleTranslation: '我的朋友坐在我旁边。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_near',
    phrase: 'near...',
    phonetic: '/nɪr/',
    meaning: '在……附近',
    usageScenario: '描述距离不远，但不如next to那么近',
    example: 'My home is near the school.',
    exampleTranslation: '我家在学校附近。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_near_the_window',
    phrase: 'near the window',
    phonetic: '/nɪr ðə ˈwɪndoʊ/',
    meaning: '在窗户附近',
    usageScenario: '描述物体或人靠近窗户的位置',
    example: 'I sit near the window.',
    exampleTranslation: '我坐在窗户附近。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 前后
  {
    id: 'prep_in_front_of',
    phrase: 'in front of',
    phonetic: '/ɪn frʌnt əv/',
    meaning: '在……前面',
    usageScenario: '描述某物位于另一物体的前方',
    example: 'There is a tree in front of my house.',
    exampleTranslation: '我家房子前面有一棵树。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_in_front_of_me',
    phrase: 'in front of me',
    phonetic: '/ɪn frʌnt əv miː/',
    meaning: '在我前面',
    usageScenario: '描述某人或某物在自己前方',
    example: 'The teacher stands in front of me.',
    exampleTranslation: '老师站在我前面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_behind',
    phrase: 'behind...',
    phonetic: '/bɪˈhaɪnd/',
    meaning: '在……后面',
    usageScenario: '描述某物位于另一物体的后方',
    example: 'The garden is behind the house.',
    exampleTranslation: '花园在房子后面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_behind_the_door',
    phrase: 'behind the door',
    phonetic: '/bɪˈhaɪnd ðə dɔːr/',
    meaning: '在门后面',
    usageScenario: '描述物体藏在或放置在门后',
    example: 'The cat is hiding behind the door.',
    exampleTranslation: '猫躲在门后面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'prep_behind_me',
    phrase: 'behind me',
    phonetic: '/bɪˈhaɪnd miː/',
    meaning: '在我后面',
    usageScenario: '描述某人或某物在自己后方',
    example: 'My friend is standing behind me.',
    exampleTranslation: '我的朋友站在我后面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 中间
  {
    id: 'prep_between',
    phrase: 'between...and...',
    phonetic: '/bɪˈtwiːn/',
    meaning: '在……和……之间',
    usageScenario: '描述某物位于两个物体中间',
    example: 'The park is between the school and the library.',
    exampleTranslation: '公园在学校和图书馆之间。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 远近
  {
    id: 'prep_far_from',
    phrase: 'far from',
    phonetic: '/fɑːr frɒm/',
    meaning: '离……很远',
    usageScenario: '描述距离遥远',
    example: 'My school is far from my home.',
    exampleTranslation: '我的学校离家很远。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_far_away',
    phrase: 'far away',
    phonetic: '/fɑːr əˈweɪ/',
    meaning: '很远',
    usageScenario: '描述距离遥远的地方',
    example: 'The mountain is far away.',
    exampleTranslation: '那座山很远。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 方向
  {
    id: 'prep_to',
    phrase: 'to...',
    phonetic: '/tuː/',
    meaning: '朝向……/ 去……',
    usageScenario: '描述方向或目的地',
    example: 'I go to school every day.',
    exampleTranslation: '我每天都去学校。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_from',
    phrase: 'from...',
    phonetic: '/frɒm/',
    meaning: '从……',
    usageScenario: '描述起点或来源',
    example: 'I come from Beijing.',
    exampleTranslation: '我来自北京。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },

  // 其他位置
  {
    id: 'prep_at',
    phrase: 'at...',
    phonetic: '/æt/',
    meaning: '在……（某地点）',
    usageScenario: '描述具体的地点或位置',
    example: 'I am at the bus stop.',
    exampleTranslation: '我在公交车站。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'prep_by',
    phrase: 'by...',
    phonetic: '/baɪ/',
    meaning: '在……旁边',
    usageScenario: '描述靠近某物或某人旁边',
    example: 'The book is by the lamp.',
    exampleTranslation: '书在台灯旁边。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'prep_over',
    phrase: 'over...',
    phonetic: '/ˈoʊvər/',
    meaning: '在……上方（不接触）',
    usageScenario: '描述某物悬在另一物体上方',
    example: 'There is a bird flying over the tree.',
    exampleTranslation: '有一只鸟在树上飞。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },
  {
    id: 'prep_above',
    phrase: 'above...',
    phonetic: '/əˈbʌv/',
    meaning: '在……之上（不接触）',
    usageScenario: '描述位置高于某物但不接触',
    example: 'The picture is above the desk.',
    exampleTranslation: '那幅画在桌子上面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },
  {
    id: 'prep_below',
    phrase: 'below...',
    phonetic: '/bɪˈloʊ/',
    meaning: '在……之下',
    usageScenario: '描述位置低于某物',
    example: 'The cat is below the chair.',
    exampleTranslation: '猫在椅子下面。',
    category: 'time_place',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },
];